
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.48 11.9499C14.65 11.9699 14.82 11.9999 15 11.9999C17.21 11.9999 19 10.2099 19 7.99994C19 5.78994 17.21 3.99994 15 3.99994C12.79 3.99994 11 5.78994 11 7.99994C11 8.17994 11.03 8.34994 11.05 8.51994L14.48 11.9499ZM16.69 14.1599L22.43 19.8999C22.76 19.7299 23 19.3999 23 18.9999V17.9999C23 15.8599 19.44 14.4999 16.69 14.1599ZM2.11998 2.41994C1.72998 2.02994 1.09998 2.02994 0.70998 2.41994C0.31998 2.80994 0.31998 3.43994 0.70998 3.82994L3.99998 7.11994V9.99994H1.99998C1.44998 9.99994 0.99998 10.4499 0.99998 10.9999C0.99998 11.5499 1.44998 11.9999 1.99998 11.9999H3.99998V13.9999C3.99998 14.5499 4.44998 14.9999 4.99998 14.9999C5.54998 14.9999 5.99998 14.5499 5.99998 13.9999V11.9999H8.87998L11.39 14.5099C9.18998 15.1099 6.99998 16.2999 6.99998 17.9999V18.9999C6.99998 19.5499 7.44998 19.9999 7.99998 19.9999H16.88L20.17 23.2899C20.56 23.6799 21.19 23.6799 21.58 23.2899C21.97 22.8999 21.97 22.2699 21.58 21.8799L2.11998 2.41994ZM5.99998 9.99994V9.11994L6.87998 9.99994H5.99998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-person-add-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPersonAddDisabled

    ```js
    <b-new-b-icon-person-add-disabled />
    ```
</docs>


